import React, { FC, useEffect, useState } from 'react';

import { TicketsSystems } from 'src/common/components/tickets-systems/TicketsSystems';
import { Report } from 'src/common/types/ReportModel';

import {
	MobileScreenshotDetails,
	scaleMobileScreenshotDetails
} from '../../helpers/MobileScreenshotScaler';

interface IMobileTicketsSystems {
	issue: Report;
}

/**
 * Mobile-specific wrapper for TicketsSystems that handles screenshot scaling
 * Scales bounding boxes from viewport coordinates to image coordinates before export
 */
export const MobileTicketsSystems: FC<IMobileTicketsSystems> = ({ issue }) => {
	const [scaledIssue, setScaledIssue] = useState<Report>(issue);

	useEffect(() => {
		const scaleIssueScreenshot = async (): Promise<void> => {
			// Type guard to check if screenshotDetails has viewport dimensions
			const hasViewportDimensions = (
				details: typeof issue.screenshotDetails
			): details is MobileScreenshotDetails => {
				const extendedDetails = details as Partial<MobileScreenshotDetails>;
				return !!extendedDetails?.viewportWidth && !!extendedDetails?.viewportHeight;
			};

			// If screenshotDetails includes viewport dimensions, scale boxes for the service
			if (hasViewportDimensions(issue.screenshotDetails)) {
				const scaledScreenshotDetails = await scaleMobileScreenshotDetails(issue.screenshotDetails);
				setScaledIssue({
					...issue,
					screenshotDetails: scaledScreenshotDetails
				});
			} else {
				setScaledIssue(issue);
			}
		};

		scaleIssueScreenshot();
	}, [issue]);

	return <TicketsSystems issue={scaledIssue} />;
};
